import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import OLTileLayer from 'ol/layer/Tile'

const TileLayer = ({ source, zIndex = 0 }) => {
  const olMap = useSelector((state) => state.mapStates.olMap)

  useEffect(() => {
    if (!olMap || !source) return null
    const layer = new OLTileLayer({
      source: source,
    })
    layer.setZIndex(zIndex)

    olMap.addLayer(layer)

    return () => {
      if (olMap) {
        olMap.removeLayer(layer)
      }
    }
  }, [olMap, source, zIndex])

  return null
}

export default TileLayer
